/** Shared Brixigo / attendance roster UI tokens — keep in sync with AttendanceLayout. */

export const rosterTheme = {
  page: "max-w-6xl mx-auto px-4 md:px-6 py-6 space-y-6",
  card: "bg-white border border-slate-200 rounded-xl shadow-sm",
  cardPad: "bg-white border border-slate-200 rounded-xl shadow-sm p-4 md:p-5",
  cardHeader: "text-base font-semibold text-slate-900",
  cardSub: "text-sm text-slate-500",
  label: "block text-sm font-medium text-slate-700 mb-1",
  input:
    "w-full border border-slate-200 rounded-lg px-3 py-2 text-sm text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-teal-500/30 focus:border-teal-500",
  select:
    "w-full border border-slate-200 rounded-lg px-3 py-2 text-sm text-slate-900 focus:outline-none focus:ring-2 focus:ring-teal-500/30 focus:border-teal-500",
  btnPrimary:
    "px-4 py-2 text-sm font-medium bg-teal-600 text-white rounded-lg hover:bg-teal-700 disabled:opacity-50 transition shadow-sm",
  btnSecondary:
    "px-4 py-2 text-sm font-medium border border-slate-200 text-slate-700 rounded-lg bg-white hover:bg-slate-50 transition",
  btnDanger: "text-sm text-red-600 hover:text-red-800 font-medium",
  btnGhost: "text-sm text-teal-700 hover:text-teal-900 font-medium",
  badge: (tone) =>
    ({
      draft: "bg-slate-100 text-slate-700",
      pending_approval: "bg-amber-100 text-amber-900",
      approved: "bg-blue-100 text-blue-800",
      published: "bg-teal-100 text-teal-900",
      frozen: "bg-slate-200 text-slate-800",
      archived: "bg-slate-100 text-slate-500",
    }[tone] || "bg-slate-100 text-slate-700"),
  periodBox: "rounded-lg bg-slate-50 border border-slate-100 px-3 py-2 text-sm text-slate-600",
};
